
export const vaultPoolConfig = {
} as const
